export default __webpack_public_path__ + "static/media/gun-industry-page.7a3d60ff.jpg";